import { toast } from "sonner";
import { Headphones, PhoneOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/StatusBits";
import { Transcript } from "@/components/dialer/ContactPanel";
import { usePhone } from "@/context/PhoneContext";
import { api, errMsg, label } from "@/lib/api";

export const LiveCalls = ({ calls }) => {
  const { takeover, active } = usePhone();
  const end = async (id) => {
    try {
      await api.post(`/ai-calls/${id}/end`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  if (!calls.length) return <p className="text-xs text-slate-500" data-testid="live-calls-empty">No active calls.</p>;
  return (
    <div className="space-y-2" data-testid="live-calls">
      {calls.map((c) => (
        <div key={c.id} className="rounded-md border border-slate-200 p-2.5 space-y-2" data-testid={`live-call-${c.id}`}>
          <div className="flex items-center justify-between gap-2">
            <div className="min-w-0">
              <p className="text-sm font-medium truncate">{c.contact_name || c.from_number}</p>
              <p className="text-[11px] text-slate-500">{label(c.mode)} · from {c.from_number}</p>
            </div>
            <StatusBadge value={c.takeover ? "in_progress" : c.status}>{c.takeover ? "Agent on call" : undefined}</StatusBadge>
          </div>
          {c.mode === "ai" && <Transcript items={(c.transcript || []).slice(-6)} />}
          {c.mode === "ai" && (
            <div className="flex gap-2">
              {!c.takeover && c.status === "in_progress" && (
                <Button size="sm" data-testid={`takeover-btn-${c.id}`} disabled={!!active} className="bg-blue-600 hover:bg-blue-700" onClick={() => takeover(c.id, c.contact_name)}>
                  <Headphones className="h-4 w-4 mr-1" /> Take over
                </Button>
              )}
              {!c.takeover && (
                <Button size="sm" variant="outline" data-testid={`end-ai-call-btn-${c.id}`} onClick={() => end(c.id)}><PhoneOff className="h-4 w-4 mr-1" /> End</Button>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
